import "./index.scss";
import React, { ReactNode } from "react";
import cn from "classnames";

type Props = {
  children: ReactNode;
  isOpen: boolean;
  isSlideRight?: boolean;
  fullClose?: boolean;
};

const MenuOverlaySlider = ({
  children,
  isOpen,
  isSlideRight,
  fullClose,
}: Props) => (
  <div
    className={cn("menu-overlay", {
      "menu-overlay--show": isOpen,
      "menu-overlay--slide-right": isSlideRight,
      "menu-overlay--full-close": fullClose,
    })}
  >
    <div className="menu-overlay__wrapper">
      <div className="menu-overlay__content">{children}</div>
    </div>
  </div>
);

export default MenuOverlaySlider;
